import { render } from "./ImpairmentCard.vue?vue&type=template&id=74508381"
import script from "./ImpairmentCard.vue?vue&type=script&lang=js"
export * from "./ImpairmentCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__